import { goToToday } from '../actions/goToToday';
import { store } from 'owa-calendar-module-command';
import { observableTodayChanged } from 'owa-observable-datetime';
import { orchestrator } from 'satcheljs';

orchestrator(observableTodayChanged, actionMessage => {
    if (!store.moduleCommand) {
        goToToday();
    }
});
